import React, { createContext, useState, useEffect } from "react";
import storage from "utils/functions/storage";
import OtpValidationModal from "components/OtpValidationModal";

export const TokenContext = createContext();

function TokenProvider({ children }) {
  const [currentTokenDocument, setCurrentTokenDocument] = useState(null);
  const [lastUsedToken, setLastUsedToken] = useState(null);
  const [otpValidationModalVisible, setOtpValidationModalVisible] = useState(
    false
  );

  const clearTokenInfo = () => {
    setCurrentTokenDocument(null);
    setLastUsedToken(null);
  };

  const handleTokenVerify = (token, document) => {
    setOtpValidationModalVisible(false);
    if (document !== "same-document") {
      setCurrentTokenDocument(document);
    }
    storage.setItem("current-token-document", document);
    if (
      !lastUsedToken ||
      (document !== currentTokenDocument && document !== "same-document") ||
      lastUsedToken !== token
    ) {
      setLastUsedToken(token);
      storage.setItem("last-used-token", token);
      return true;
    }
    setOtpValidationModalVisible(true);
    return false;
  };

  useEffect(() => {
    const tokenDocument = storage.getItem("current-token-document");
    const lastToken = storage.getItem("last-used-token");
    setCurrentTokenDocument(tokenDocument);
    setLastUsedToken(lastToken);
    setOtpValidationModalVisible(false);
  }, []);

  return (
    <TokenContext.Provider
      value={{
        currentTokenDocument,
        setCurrentTokenDocument,
        lastUsedToken,
        setLastUsedToken,
        clearTokenInfo,
        handleTokenVerify,
      }}
    >
      {children}
      {otpValidationModalVisible && (
        <OtpValidationModal
          confirmAction={() => setOtpValidationModalVisible(false)}
          currentOtp={lastUsedToken}
        />
      )}
    </TokenContext.Provider>
  );
}

export default TokenProvider;
